<div class="calendar-day-view">
  <p-calendar [monthNavigator]="false" [yearNavigator]="false" (onSelect)="dateChanged($event)" [(ngModel)]="date" [inline]="true">
    <ng-template pTemplate="date" let-date>
      <div class="diary-calendar-day">
        <span class="diary-calendar-has-events" *ngIf="hasEvents(date)"></span>        
        <span [ngStyle]="{backgroundColor: getColor(date)}" class="diary-calendar-day">{{date.day}}</span>
      </div>
    </ng-template>
  </p-calendar>
</div>
